// Version of the catalogue items embedded in the engine.
//
// Any catalogue item change must bump this constant and regenerate the import template
// (`npm run gabarit`) in the same delivery. An older template version only warns on import.
export const CATALOGUE_VERSION = 30;
